
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"7","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.883 4l-7.527 6.235L2 11l9-7.521L2-4l-.645.764L8.884 3H-13v1H8.883z"}})])
          )
        }
      }
    